import React from 'react';

interface AvatarProps {
  firstName: string;
  lastName: string;
  /** Pixel size: 'sm' = 32px, 'md' = 40px. Default 'sm'. */
  size?: 'sm' | 'md';
}

/** Deterministic color from initials — same user always gets the same color */
const avatarColor = (firstName?: string, lastName?: string): string => {
  const code = (firstName?.charCodeAt(0) || 0) + (lastName?.charCodeAt(0) || 0);
  return `var(--avatar-${code % 6})`;
};

const sizeMap = {
  sm: { outer: 'h-8 w-8', text: 'text-xs' },
  md: { outer: 'h-10 w-10', text: 'text-sm' },
};

const Avatar: React.FC<AvatarProps> = ({ firstName, lastName, size = 'sm' }) => {
  const s = sizeMap[size];
  return (
    <div
      className={`${s.outer} rounded-full flex items-center justify-center flex-shrink-0`}
      style={{ background: avatarColor(firstName, lastName) }}
    >
      <span className={`${s.text} font-semibold text-white`}>
        {firstName[0]}{lastName[0]}
      </span>
    </div>
  );
};

export { avatarColor };
export default Avatar;
